import { memo, useCallback } from "react";
import Demo from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Demo/Demo";
import Name from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Name/Name";
import Highlight from "./Highlight/Highlight";
import LoadingViewerTop from "@coworker/apprestructured/src/task-management/components/TaskViewerSheet/ViewerTop/LoadingViewerTop/LoadingViewerTop";

function LoadingViewerTopDemo() {
  const handleCloseClick = useCallback(() => {
    alert("onCloseButtonClick");
  }, []);

  return (
    <Demo>
      <Name>LoadingViewerTop</Name>
      <Highlight>
        <LoadingViewerTop onCloseButtonClick={handleCloseClick} />
      </Highlight>
    </Demo>
  );
}

export default memo(LoadingViewerTopDemo);
